var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { KeycloakService } from '../../services/keycloak.service';
import { CommonService } from '../../services/common.service';
import { PerfilService } from '../../services/perfil.service';
import { UsuarioService } from '../../services/usuario.service';
import { PerfilPopupComponent } from './perfil-popup.component';
import { SearchService } from '../../services/search.service';
import { ActivatedRoute } from '@angular/router';
var PerfilComponent = (function () {
    function PerfilComponent(_http, route, _service, _comService, _pflService, _usrService) {
        this._http = _http;
        this.route = route;
        this._service = _service;
        this._comService = _comService;
        this._pflService = _pflService;
        this._usrService = _usrService;
        this.activateList = false;
        this.curPage = 0;
        this.muestraPaginas = true;
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    PerfilComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.pflPopup.onClose.subscribe(function (event) { _this.closePopup(); });
        this.find();
    };
    PerfilComponent.prototype.find = function () {
        var _this = this;
        this.muestraPaginas = true;
        this.curPage = 0;
        this._pflService.findPerfiles(this.curPage).subscribe(function (response) {
            _this.perfilList = response;
            _this.pages = new Array(Math.ceil(_this.perfilList.total / _this.perfilList.size)).map(function (x, i) { return i; });
            _this.curPage = 0;
            _this.activateList = (_this.perfilList.total > 0);
            if (_this.perfilList.total == 0) {
                _this.showErrorMessage("No se han encontrado resultados");
            }
            _this._comService.emitBlocking(false);
        });
    };
    PerfilComponent.prototype.prevPage = function () {
        var _this = this;
        if (this.curPage > 0) {
            this.curPage = this.curPage - 1;
            this._pflService.findPerfiles(this.curPage).subscribe(function (response) {
                _this.perfilList = response;
                _this.pages = new Array(Math.ceil(_this.perfilList.total / _this.perfilList.size)).map(function (x, i) { return i; });
            });
            //console.log("<< " + this.curPage);
        }
    };
    PerfilComponent.prototype.goToPage = function (index) {
        var _this = this;
        this.curPage = index;
        this._pflService.findPerfiles(index).subscribe(function (response) {
            _this.perfilList = response;
            _this.pages = new Array(Math.ceil(_this.perfilList.total / _this.perfilList.size)).map(function (x, i) { return i; });
            _this.curPage = index;
            //console.log(">> " + this.curPage);
        });
    };
    PerfilComponent.prototype.nextPage = function () {
        var _this = this;
        if (this.curPage < this.pages.length - 1) {
            this.curPage = this.curPage + 1;
            this._pflService.findPerfiles(this.curPage).subscribe(function (response) {
                _this.perfilList = response;
                _this.pages = new Array(Math.ceil(_this.perfilList.total / _this.perfilList.size)).map(function (x, i) { return i; });
                //console.log(">> " + this.curPage);
            });
        }
    };
    PerfilComponent.prototype.onClickNew = function () {
        this.pflPopup.newPfl();
    };
    PerfilComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    PerfilComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    PerfilComponent.prototype.editPfl = function (pfl) {
        //console.log("Editar perfil " + JSON.stringify(pfl));
        this.pflPopup.loadPfl(pfl);
    };
    PerfilComponent.prototype.closePopup = function () {
        //console.log("cerro popup");
        this.find();
    };
    PerfilComponent.prototype.deletePfl = function (id) {
        var _this = this;
        this._pflService.deletePfl(id, KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.deleteCorrecto = response;
            var that = _this;
            that._pflService.findPerfiles(that.curPage).subscribe(function (response) {
                that.perfilList = response;
                that.pages = new Array(Math.ceil(that.perfilList.total / that.perfilList.size)).map(function (x, i) { return i; });
                //console.log(">> " + that.curPage);
            });
        });
    };
    return PerfilComponent;
}());
__decorate([
    ViewChild(PerfilPopupComponent),
    __metadata("design:type", PerfilPopupComponent)
], PerfilComponent.prototype, "pflPopup", void 0);
PerfilComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'perfil',
        templateUrl: 'perfil.component.html'
    }),
    __metadata("design:paramtypes", [Http,
        ActivatedRoute,
        SearchService,
        CommonService,
        PerfilService,
        UsuarioService])
], PerfilComponent);
export { PerfilComponent };
//# sourceMappingURL=perfil.component.js.map